<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style lang="scss" >
.ql-editor .ql-video {
    display: block;
    max-width: 100%;
    width: 100% !important;
    height: 300px !important;
}
.ql-editor blockquote, .ql-editor h1, .ql-editor h2, .ql-editor h3, .ql-editor h4, .ql-editor h5, .ql-editor h6, .ql-editor ol, .ql-editor p, .ql-editor pre, .ql-editor ul {
    margin: 0;
    padding: 0;
    counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    font-size: 15px !important;
}
</style>
